// extracted by mini-css-extract-plugin
export default {"updateNotifier":"UpdateNotifier_updateNotifier__3mQ8b"};